
import React from "react";
import { Route, Routes } from "react-router-dom";
import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import CalculatorPage from "@/pages/CalculatorPage";
import NursingHomePage from "@/pages/NursingHomePage";
import CountyPage from "@/pages/CountyPage";
import AllNursingHomes from "@/pages/AllNursingHomes";
import AllNursingHomesMapPage from "@/pages/AllNursingHomesMapPage";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import OwnerDashboardPage from "@/pages/OwnerDashboardPage";
import OwnerNursingHomePage from "@/pages/OwnerNursingHomePage";
import LeadDetailPage from "@/pages/LeadDetailPage";
import GuidePage from "@/pages/GuidePage";
import GuideDetailPage from "@/pages/GuideDetailPage";
import PressPage from "@/pages/PressPage";
import CareersPage from "@/pages/CareersPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ThankYouPage from "@/pages/ThankYouPage";
import WaitlistPage from "@/pages/WaitlistPage";
import TermsPage from "@/pages/legal/TermsPage";
import CookiesPage from "@/pages/legal/CookiesPage";
import EmailTestPage from "@/pages/EmailTestPage";
import AdminGuidePage from "@/pages/AdminGuidePage";
import ClaimsManagementPage from "@/pages/admin/ClaimsManagementPage";
import AdminToolsPage from "@/pages/admin/AdminToolsPage";
import JobsPage from "@/pages/JobsPage";
import DesignSystemRoutes from "@/components/design-system/DesignSystemRoutes";
import EmailVerificationPage from "@/components/auth/verify/EmailVerificationPage";
import NursingHomeLookupPage from "@/pages/NursingHomeLookupPage";
import Sitemap from "@/components/seo/Sitemap";
import ClaimNursingHomePage from "@/pages/ClaimNursingHomePage";

// Owner dashboard pages
import OverviewPage from "@/pages/owner/OverviewPage";
import ProfilePage from "@/pages/owner/ProfilePage";
import MediaPage from "@/pages/owner/MediaPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      
      {/* Core pages */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/fair-deal-calculator" element={<CalculatorPage />} />
      <Route path="/guides" element={<GuidePage />} />
      <Route path="/guides/:slug" element={<GuideDetailPage />} />
      <Route path="/press" element={<PressPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/jobs" element={<JobsPage />} />
      
      {/* Nursing homes */}
      <Route path="/nursing-homes" element={<AllNursingHomes />} />
      <Route path="/nursing-homes/map" element={<AllNursingHomesMapPage />} />
      <Route path="/nursing-homes/:countySlug" element={<CountyPage />} />
      <Route path="/nursing-homes/:countySlug/:nursingHomeSlug" element={<NursingHomePage />} />
      <Route path="/nursing-homes-lookup/:nhSlug" element={<NursingHomeLookupPage />} />
      <Route path="/claim/:nursingHomeSlug" element={<ClaimNursingHomePage />} />
      
      {/* Auth and user routes */}
      <Route path="/auth/:mode" element={<Auth />} />
      <Route path="/auth/verify-email" element={<EmailVerificationPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/leads/:id" element={<LeadDetailPage />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      
      {/* Owner routes */}
      <Route path="/owner/dashboard" element={<OwnerDashboardPage />} />
      <Route path="/owner/nursing-homes/:nhSlug" element={<OwnerNursingHomePage />}>
        <Route index element={<OverviewPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="media" element={<MediaPage />} />
        <Route path="leads" element={<NotFound />} />
        <Route path="staff" element={<NotFound />} />
        <Route path="calendar" element={<NotFound />} />
        <Route path="settings" element={<NotFound />} />
      </Route>
      
      {/* Admin routes */}
      <Route path="/admin/guides" element={<AdminGuidePage />} />
      <Route path="/admin/claims" element={<ClaimsManagementPage />} />
      <Route path="/admin/tools" element={<AdminToolsPage />} />
      <Route path="/email-test" element={<EmailTestPage />} />
      
      {/* Legal */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/legal/terms-of-use" element={<TermsPage />} />
      <Route path="/terms-of-use" element={<TermsPage />} />
      <Route path="/legal/cookies" element={<CookiesPage />} />
      
      {/* Sitemap routes */}
      <Route path="/sitemap.xml" element={<Sitemap path="/sitemap.xml" />} />
      <Route path="/sitemaps/main.xml" element={<Sitemap path="/sitemaps/main.xml" />} />
      <Route path="/sitemaps/nursing-homes.xml" element={<Sitemap path="/sitemaps/nursing-homes.xml" />} />
      <Route path="/sitemaps/counties.xml" element={<Sitemap path="/sitemaps/counties.xml" />} />
      <Route path="/sitemaps/content.xml" element={<Sitemap path="/sitemaps/content.xml" />} />
      
      {/* Design system */}
      <Route path="/design-system/*" element={<DesignSystemRoutes />} />
      
      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
